import {Component} from "@angular/core";
import {MigrateService} from "./migrate.service";

@Component({
  templateUrl: "./migrate.template.pug",
  providers: [MigrateService],
})
export class MigrateComponent {
  error: Error;
  status: string = "";
  progress: string = "0%";
  migrating: boolean = false;
  complete: boolean = false;

  projectId: string = "";
  environmentName: string = "pro";

  environments = [
    {key: "pro", value: "Production", url: "tmc.ext.hp.com"},
    {key: "pro2", value: "Production", url: "tmc.ext.hp.com"},
    {key: "training", value: "Training", url: "tmc-training.msit.hpcloud.hp.com"},
    {key: "itg", value: "Integration", url: "tmc-itg.msit.hpcloud.hp.com"},
    {key: "itg2", value: "Integration", url: "tmc-itg2.msit.hpcloud.hp.com"},
    {key: "dev", value: "Development", url: "tmc-dev.msit.hpcloud.hp.com"},
    {key: "dev2", value: "Development", url: "tmc-dev2.msit.hpcloud.hp.com"},
  ];

  constructor(public migrateService: MigrateService) {
    this.migrateService.error.subscribe((error) => {
      this.error = error;
      this.complete = false;
      this.migrating = false;
    });

    this.migrateService.progress.subscribe((result) => {
      let progressNumber = result.progress;
      if (Number.isNaN(progressNumber)) progressNumber = 0;
      progressNumber = Math.round(progressNumber * 100);

      this.progress = `${progressNumber}%`;
      this.status = result.status;
      this.migrating = !result.complete;
      this.complete = result.complete;
    });
  }

  migrate() {
    this.error = undefined;
    this.migrating = true;
    this.complete = false;
    this.status = undefined;
    this.progress = "0%";
    this.migrateService.migrate(this.projectId, this.environmentName);
  }
}
